import React from 'react';
import { Link } from 'react-router-dom';
import { withSimoSub } from 'decorators/withSub';

const component = ({ sub, isBackToSub = true, withDeviceLink }) => (
  <div className="SubNav">
    <div className="flex-justify-space-between d-flex-vc">
      <div>
        <h3>
          {sub.first_name} {sub.last_name}
        </h3>
        <p className="links">
          {isBackToSub ? (
            <Link to={`/simo/subscriptions/${sub.id}/view`}>
              &larr; Back to Sub
            </Link>
          ) : (
            <Link to={`/users/${sub.user_profile}/view`}>
              &larr; Back to User
            </Link>
          )}
        </p>
      </div>
      {withDeviceLink && (
        <Link to={`/simo/devices/${sub.device}/view`}>
          <button className="btn btn-default">
            <img
              src="/images/icons/subActions/link-icon.svg"
              alt=""
              style={{ width: '16px', marginRight: '5px', marginBottom: '2px' }}
            />
            View Device
          </button>
        </Link>
      )}
    </div>
  </div>
);

export const SubNav = component;
export default withSimoSub(component);
